export default function (string) {
  let result = '';

  if (!string) {
    return result;
  }

  try {
    result = decodeURIComponent(string);
  } catch {
    result = string;
  } finally {
    return result;
  }
};
